import * as React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { BranchNodeEdge } from '../master/Branch/constants';
import moment from 'moment';
import { ApprovalNodeEdgeQuery } from './constants';

export const ApprovalReceiptSugarHigh: React.FunctionComponent<Props> = (
  props,
) => {
  return (
    <Document>
      <Page
        size={{ width: 215, height: 1000 }}
        style={[styles.body, { margin: '0px', padding: '2px' }]}
      >
        <View>
          <Text style={[{ fontSize: 12, textAlign: 'center' }]}>
            {props.branch.name}
          </Text>
        </View>
        <View>
          <Text style={[{ fontSize: 6, textAlign: 'center' }]}>
            {props.branch.address}, {props.branch.contactNo}
          </Text>
        </View>
        <View style={[styles.inline]}>
          <Text style={[styles.author, styles.boxMargin, styles.inlineHead]}>
            Date: {moment(props.approval.date).format('DD-MM-YYYY')}
          </Text>
        </View>
        <View style={[styles.inline]}>
          <Text style={[styles.author, styles.boxMargin, styles.inlineHead]}>
            NC No. {props.approval.approvalNo}
          </Text>
        </View>
        <View style={[styles.inline]} />
        <View style={[styles.inline]} />
        <View style={[styles.inline]}>
          <Text style={[styles.author, styles.boxMargin, styles.inlineHead]}>
            Name: {props.approval.customer?.name}
          </Text>
          <Text style={[styles.author, styles.boxMargin, styles.inlineHead]}>
            {}
          </Text>
        </View>
        <View style={[styles.inline]}>
          <Text style={[styles.author, styles.boxMargin, styles.inlineHead]}>
            Address: {props.approval.customer?.address}
          </Text>
        </View>
        <View style={[{ height: 'auto' }]}>
          <View style={[styles.inline]}>
            <Text
              style={[
                styles.author,
                styles.boxMargin,
                styles.minFlex,
                { fontWeight: 'bold', flex: 3 },
              ]}
            >
              SL.
            </Text>
            <Text
              style={[
                styles.author,
                styles.boxMargin,
                styles.inlineHead,
                { fontWeight: 'bold', flex: 6 },
              ]}
            >
              ITEM
            </Text>
            <Text
              style={[
                styles.author,
                styles.boxMargin,
                styles.inlineHeadDouble,
                { fontWeight: 'bold', textAlign: 'left' },
              ]}
            >
              QTY.
            </Text>
            <Text
              style={[
                styles.author,
                styles.boxMargin,
                styles.minFlex,
                { fontWeight: 'bold', textAlign: 'left' },
              ]}
            >
              RATE
            </Text>
            <Text
              style={[
                styles.author,
                styles.boxMargin,
                styles.inlineHeadDouble,
                { fontWeight: 'bold', textAlign: 'left' },
              ]}
            >
              AMOUNT
            </Text>
          </View>
          {props.approval.productDetails.edges.map((p, i) => (
            <View style={[styles.inline]}>
              <Text
                style={[
                  styles.author,
                  styles.snoflex,
                  styles.heading,
                  { textAlign: 'left' },
                ]}
              >
                {i + 1}.
              </Text>
              <Text
                style={[
                  styles.author,
                  styles.inlineHead,
                  styles.heading,
                  { textAlign: 'left' },
                ]}
              >
                {p.node.product?.name}
              </Text>
              <Text
                style={[
                  styles.author,
                  styles.inlineHeadDouble,
                  styles.heading,
                  { textAlign: 'left' },
                ]}
              >
                {p.node.quantity}
              </Text>
              <Text
                style={[
                  styles.author,
                  styles.inlineHeadDouble,
                  styles.heading,
                  { textAlign: 'left' },
                ]}
              >
                {Number(p.node.rate).toFixed(2)}
              </Text>
              <Text
                style={[
                  styles.author,
                  styles.boxMargin,
                  styles.inlineHeadDouble,
                  { fontWeight: 'bold', textAlign: 'left' },
                ]}
              >
                {Number(p.node.amount).toFixed(2)}
              </Text>
            </View>
          ))}
        </View>
        <View style={[styles.author, styles.boxMargin, styles.price]}>
          <Text style={[styles.minFlex]}>{}</Text>
          <Text style={[styles.minFlex]}>
            Net Total : {Math.round(props.approval.totalMrp).toFixed(2)}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 0,
  },
  author: {
    fontSize: 10,
  },

  minFlex: { flex: 5 },
  inlineHead: { flex: 9 },
  inlineHeadDouble: { flex: 5 },
  boxMargin: { margin: 1 },
  inline: { flexDirection: 'row' },
  heading: { fontWeight: 'bold' },
  snoflex: { flex: 3 },
  price: { marginRight: '10%', textAlign: 'right' },
});

interface Props {
  approval: ApprovalNodeEdgeQuery;
  branch: BranchNodeEdge;
}
